// extracted by mini-css-extract-plugin
export default {"subscription-alert-banner":"style_subscription-alert-banner__tBDnE","subscription-alert-banner-content":"style_subscription-alert-banner-content__4xs00"};